import { isValidElement, ReactNode } from 'react'
import { Trans } from 'react-i18next'

export const isTransElement = (node: ReactNode): boolean => {
  return isValidElement(node) && node.type === Trans
}
